import { WebsiteUrl } from "../../../utils";
import Loading from "../../../utils/Loading"; //获取加载组件
import { ElMessage, ElMessageBox } from "element-plus";
import Sidentify from "../../../components/Sidentify";//引入验证码组件
import Api_Member from "../../../api/FrontEnd/Member";

export default {
	name: 'ResetPassword',
	components: {
		Sidentify
	},
	props:{
		onShow:{
			type:Boolean,
			default:false,
		}
	},
	data(){
        var CheckPassword = (rule, value, callback) => {
            if (value !== this.ResetPasswordForm.Password) {
                callback(new Error("两次输入密码不一致"));
            }else{
				callback();
			}
        };
		return{
			Visible:false,

			ImageLogoUrl:WebsiteUrl()+'/images/ModuleBoxTopBodyBodyLogo.png',

			CaptchaValue:this.GetIdentifyCode(),

			ResetPasswordForm:{},
			ResetPasswordRules:{
				Username:[
					{
						required:true,
						message:"请输入登录账号",
						trigger:"blur"
					},
				],
				Email:[
					{
						required:true,
						message:"请输入电子邮箱",
						trigger:"blur"
					},
				],
				Phone:[
					{
						required:true,
						message:"请输入手机号码",
						trigger:"blur"
					},
				],
				Password:[
					{
						required:true,
						message:"请输入新密码",
						trigger:"blur"
					},
					{
						min:8,
						max:32,
						message:'长度在 8 到 32 个字符',
						trigger:'blur',
					}
				],
				Password2:[
					{
						required:true,
						message:"请输入确认密码",
						trigger:"blur"
					},
					{
						validator: CheckPassword,
						trigger: 'blur'
					},
				],
				Captcha:[
					{
						required:true,
						message:"请输入验证码",
						trigger:"blur"
					},
				],
			},
		}
	},
	methods:{
		onHide(){
			this.$emit("onHide",false);
			this.Visible = false;
		},
		Init(){
			this.ResetPasswordForm = {};

		},
		ResetPasswordSubmit(){
			this.$refs.ResetPasswordFormRef.validate(async (valid) => {
				// console.log(this.$refs.ResetPasswordFormRef);
				// console.log(this.$refs.ResetPasswordFormRef.validate());
				if(valid){
					console.log(this.ResetPasswordForm);

                    // if(this.ResetPasswordForm.Captcha !== this.CaptchaValue){
                    //     this.ResetPasswordForm.Captcha = "";
					// 	this.ResetCaptcha();
                    //     ElMessage.error("验证码有误，请重新输入");
                    //     return false;
                    // }

					this.ResetCaptcha();

					//获取接口返回值
					Loading.LoadingShow();
					let RequestData = this.ResetPasswordForm;
					let ReturnData = Api_Member.MemberResetPassword(RequestData);
					ReturnData.then(response => {
						// console.log(response);
						Loading.LoadingHide();
						let State = response['Data'][0].State;
						let Message = response['Data'][0].Message;
						if(State == 'Success'){
							let Data = JSON.parse(response['Data'][0].Data);
							// console.log(Data);

							this.onBack();
							ElMessage.success(Message);
						}else{
							this.ResetPasswordForm.Captcha = "";
							ElMessage.error(Message);
						}
					})
				}else{
					ElMessage.error("请根据提示完成填写");
				}
			});
		},
		onBack(){
			this.$emit("onBack",false);
			this.Visible = false;
		},

        GetIdentifyCode() {
            const characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const idLength = 5; // 字符串长度 这里生成30位的
            let randomCode = '';

            for (let i = 0; i < idLength; i++) {
                const randomIndex = Math.floor(Math.random() * characters.length);
                randomCode += characters.charAt(randomIndex);
            }

            return randomCode;
        },
        ResetCaptcha(){
            this.ResetPasswordForm.Captcha = '';
            this.CaptchaValue = this.GetIdentifyCode();
            this.$refs.Captcha.drawPic();
        },

	},
	mounted(){

	},
	watch:{
		onShow(Value){
			this.Visible = Value;
			this.Init();
		},


	},
	emits:{
		"onHide":null,
		"onBack":null,
	}
}

